// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__s4fH0","line":"styles_line__HZ1lJ","info":"styles_info__jmKDo","copyright":"styles_copyright__PDUE8","socialIcon":"styles_socialIcon__e1Hh-"};